import { useQuery } from 'react-query';
import { CustomerAgreementsApi } from '../CustomerAgreementsApi';
import { CustomerAgreementsQueryKey } from '../queryKeys';
import { CustomerAgreementListItem } from '../types';

type CustomerAgreementsQueryOptions = {
    onError?: (error: unknown) => void;
    enabled?: boolean;
};

export function useCustomerAgreementsQuery(options: CustomerAgreementsQueryOptions = {}) {
    return useQuery<CustomerAgreementListItem[]>(
        [CustomerAgreementsQueryKey],
        () => CustomerAgreementsApi.getAllCustomerAgreements(),
        {
            onError: options.onError,
            enabled: options.enabled !== false,
            refetchOnWindowFocus: false
        }
    );
}
